//此文件作为中央仓库，用于跨组件通信
import Vue from 'vue'
export default new Vue()
